import React from 'react';
import Svg from '../Svg';

const IconLogIn04 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.9"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C8.66999 3 5.76108 4.80801 4.20343 7.50073C3.92688 7.97879 3.31516 8.14215 2.8371 7.86561C2.35904 7.58906 2.19567 6.97733 2.47222 6.49927C4.37266 3.21398 7.92719 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C7.92719 23 4.37266 20.786 2.47222 17.5007C2.19567 17.0227 2.35904 16.4109 2.8371 16.1344C3.31516 15.8579 3.92688 16.0212 4.20343 16.4993C5.76108 19.192 8.66999 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM11.2929 8.70711C10.9024 8.31658 10.9024 7.68342 11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071C10.9024 16.3166 10.9024 15.6834 11.2929 15.2929L13.5858 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H13.5858L11.2929 8.70711Z"
    />
  </Svg>
);

export default IconLogIn04;
